import { boolchange } from '../interfaces/trial.type';

const trialData: boolchange = {
  booly: false
};

export { trialData };
